// File: frontend/src/serviceWorkerRegistration.js
//
// Service workers were previously disabled outright here (see git history)
// to avoid staff getting stuck on a stale cached build of an
// actively-changing attendance tool. public/service-worker.js now handles
// that safely itself (network-first HTML shell, cache-first only for
// content-hashed static assets, /api/* never touched) -- see its own
// comments for the full reasoning. Registering it is also what's required
// for Chrome's automatic "Install app" prompt to appear on mobile; a
// manifest + icons alone only unlocks the *manual* install path.

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch((error) => {
        console.error('Service worker registration failed:', error.message);
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    }).catch((error) => {
      console.error('Service worker unregister error:', error.message);
    });
  }
}